export enum HelpState {
  closed = 'closed',
  contextualInfo = 'contextualInfo',
  glossary = 'glossary',
  introduction = 'introduction',
  support = 'support'
}
